// Disable Turbo cache in development for immediate view updates
if (process.env.NODE_ENV === 'development') {
  document.addEventListener('DOMContentLoaded', () => {
    // Clear Turbo snapshot cache on every page load
    if (window.Turbo && window.Turbo.session) {
      window.Turbo.session.pageCache.clear()
    }
  })

  // Prevent pages from being cached when navigating away
  document.addEventListener('turbo:before-cache', () => {
    if (window.Turbo && window.Turbo.session) {
      window.Turbo.session.pageCache.clear()
    }
  })

  // Clear cache after every navigation
  document.addEventListener('turbo:load', () => {
    if (window.Turbo && window.Turbo.session) {
      window.Turbo.session.pageCache.clear()
    }
  })
}
